import { render, staticRenderFns } from "./Fotter.vue?vue&type=template&id=b89fedf6&scoped=true&"
import script from "./Fotter.vue?vue&type=script&lang=js&"
export * from "./Fotter.vue?vue&type=script&lang=js&"
import style0 from "./Fotter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Fotter.vue?vue&type=style&index=1&id=b89fedf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89fedf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFooter,VRow})
